import { Component } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { Menu } from '../../models/menu';
import { Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-side-menu',
  imports: [TegelModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent {
  isMenuOpened: boolean = false;

  //icon list: https://tds-storybook.tegel.scania.com/?path=/docs/foundations-icons--gallery
  menus: Menu[] = [
    new Menu('SSD', 'dash-ssd', 'global', [
      new Menu('Exception Registration', 'dash-restException', '', null),
      new Menu('All Exception', 'dash-allssd', '', null),
    ]),
    new Menu('SSQ', 'dash-ssq', 'document', null),
    new Menu('Type Balance', 'dash-typebal', 'image', null),
    new Menu('Historical Data', 'dash-hist', 'tool', null),
    new Menu('Manage', '', 'settings', [
      new Menu('ABC Classification', 'dash-abc', '', null),
      new Menu('Material Planner', 'dash-mp', '', null),
      new Menu('Supplier', 'dash-supplier', '', null),
      new Menu('Part Number', 'dash-part-number', '', null),
    ]),
  ];

  constructor(private router: Router, private menuService: MenuService) {
    this.menuService.signal$.subscribe((value) => {
      this.mobileMenuAction(value);
    });
  }

  navigate(path: string) {
    this.isMenuOpened = false;
    this.router.navigateByUrl(path);
  }

  mobileMenuAction(action: boolean) {
    this.isMenuOpened = action;
  }
}
